export enum ToastType {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}

export interface Toast {
	id?: string | number;
	initiator?: string;
	toastType: ToastType;
	onClose?: (clicked: any) => void;
	message: string;
}

export interface ToastState {
	toasts: Toast[];
}

export const initialState: ToastState = {
	toasts: [],
};
